import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import { firebaseApp } from './firebase/firebase'
import { VueMaskDirective } from 'v-mask'
import { sync } from 'vuex-router-sync'
import JsonExcel from "vue-json-excel";
 
Vue.component("downloadExcel", JsonExcel);

require('firebase/auth')
Vue.directive('mask', VueMaskDirective)

Vue.config.productionTip = false

let app = ''

sync(store, router, { moduleName: 'RouteModule' })

export const bus = new Vue();

firebaseApp.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      vuetify,
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})